export const stoneTypes = [
  {
    id: 'hebron-stone',
    slug: 'hebron-stone',
    name: { he: 'אבן חברון', en: 'Hebron Stone' },
    meta: {
      title: {
        he: 'מצבות אבן חברון – המראה הירושלמי הקלאסי במחיר משתלם',
        en: 'Hebron Stone Tombstones – The Classic Jerusalem Look at an Affordable Price'
      },
      description: {
        he: 'מצבות אבן חברון ישירות מהמפעל. האבן הנפוצה בישראל המעניקה מראה טבעי ומכובד במחיר נגיש. עמידות, תחזוקה ואחריות ל-40 שנה באבני חן.',
        en: 'Hebron stone tombstones directly from the factory. The most common stone in Israel, providing a natural and dignified look at an accessible price. Durability, maintenance, and 40-year warranty at Avne Chen.'
      }
    },
    h1: {
      he: 'מצבות אבן חברון – המראה הירושלמי הקלאסי במחיר משתלם',
      en: 'Hebron Stone Tombstones – The Classic Jerusalem Look at an Affordable Price'
    },
    content: {
      intro: {
        he: 'אבן חברון (המוכרת גם כ\'שיש חברוני\') היא הבחירה הפופולרית ביותר בבתי העלמין בישראל, ולא בכדי. זוהי אבן גיר קשה הנחצבת באזור הרי יהודה וחברון, והיא מתאפיינת במראה \'ירושלמי\' בגוונים של לבן, קרם וצהבהב עדין.',
        en: 'Hebron Stone (also known as \'Hebroni Marble\') is the most popular choice in cemeteries in Israel, and for good reason. It is a hard limestone quarried in the Judean Mountains and Hebron area, characterized by a \'Jerusalem\' look in shades of white, cream, and delicate yellowish.'
      },
      advantages: [
        {
          title: { he: 'מחיר נגיש', en: 'Affordable Price' },
          description: { he: 'זוהי האבן הזולה ביותר מבין האפשרויות, המאפשרת להקים מצבה מכובדת גם בתקציב מוגבל.', en: 'This is the cheapest stone among the options, allowing for a dignified tombstone even on a limited budget.' }
        },
        {
          title: { he: 'מראה טבעי', en: 'Natural Look' },
          description: { he: 'מתאימה מאוד לאקלים ולאופי הבנייה בארץ.', en: 'Very suitable for the climate and building style in Israel.' }
        },
        {
          title: { he: 'עיבוד נוח', en: 'Easy Processing' },
          description: { he: 'ניתן לעצב אותה במגוון צורות וגימורים.', en: 'Can be designed in a variety of shapes and finishes.' }
        }
      ],
      suitability: {
        he: 'למי זה מתאים? למשפחות המחפשות מצבה סולידית, יפה ובתקציב נוח. חשוב לדעת שאבן חברון דורשת ניקוי תקופתי (אחת לשנה-שנתיים) כדי לשמור על הלובן שלה מפני פגעי מזג האוויר.',
        en: 'Suitable for families looking for a solid, beautiful tombstone at a comfortable budget. It is important to know that Hebron stone requires periodic cleaning (every year or two) to keep its whiteness from weather damage.'
      }
    }
  },
  {
    id: 'turkish-marble',
    slug: 'turkish-marble',
    name: { he: 'שיש טורקי', en: 'Turkish Marble' },
    meta: {
      title: {
        he: 'מצבות שיש טורקי (מרמרה) – יוקרה ובוהק בכחול-אפור',
        en: 'Turkish Marble (Marmara) Tombstones – Luxury and Shine in Blue-Gray'
      },
      description: {
        he: 'מחפשים מצבה משיש טורקי מקורי? באבני חן מייבאים את השיש ישירות מטורקיה. גוון כחלחל-אפור ייחודי, עמידות גבוהה ומראה יוקרתי.',
        en: 'Looking for an original Turkish marble tombstone? At Avne Chen, we import the marble directly from Turkey. Unique bluish-gray shade, high durability, and a luxurious look.'
      }
    },
    h1: {
      he: 'מצבות שיש טורקי (מרמרה) – יוקרה ובוהק בכחול-אפור',
      en: 'Turkish Marble (Marmara) Tombstones – Luxury and Shine in Blue-Gray'
    },
    content: {
      intro: {
        he: 'שיש ה\'מרמרה\' הטורקי נחשב לאבן האצילה של בתי העלמין. הוא מתאפיין בגוון אפור-כחלחל עם גידים עדינים, המעניקים לו מראה ייחודי ויוקרתי יותר מאבן החברון. אנו ב\'אבני חן\' מייבאים את הבלוקים ישירות מטורקיה ובוחרים רק את הסוגים הנקיים והאיכותיים ביותר.',
        en: 'Turkish \'Marmara\' marble is considered the noble stone of cemeteries. It is characterized by a gray-bluish shade with delicate veins, giving it a unique and more luxurious look than Hebron stone. At \'Avne Chen\', we import the blocks directly from Turkey and choose only the cleanest and highest quality types.'
      },
      advantages: [
        {
          title: { he: 'מראה יוקרתי', en: 'Luxurious Look' },
          description: { he: 'הברק והגוון של השיש הטורקי משדרים ניקיון וטוהר.', en: 'The shine and shade of Turkish marble radiate cleanliness and purity.' }
        },
        {
          title: { he: 'פחות ספיגה', en: 'Less Absorption' },
          description: { he: 'השיש הטורקי דחוס יותר מאבן גיר רגילה, ולכן הוא סופג פחות לכלוך וקל יותר לניקוי.', en: 'Turkish marble is denser than regular limestone, so it absorbs less dirt and is easier to clean.' }
        },
        {
          title: { he: 'עמידות', en: 'Durability' },
          description: { he: 'מחזיק מעמד היטב באקלים הישראלי החם.', en: 'Holds up well in the hot Israeli climate.' }
        }
      ],
      suitability: {
        he: 'למי זה מתאים? למשפחות המעוניינות במצבה בהירה אך עם נוכחות ויוקרה, שמוכנות להשקיע מעט יותר מאבן חברון עבור עמידות ואסתטיקה.',
        en: 'Suitable for families interested in a light-colored tombstone but with presence and luxury, who are willing to invest a little more than Hebron stone for durability and aesthetics.'
      }
    }
  },
  {
    id: 'granite-sardo',
    slug: 'granite-sardo',
    name: { he: 'גרניט סרדו', en: 'Granite Sardo' },
    meta: {
      title: {
        he: 'מצבות גרניט סרדו – עוצמה ועמידות לנצח',
        en: 'Granite Sardo Tombstones – Power and Durability Forever'
      },
      description: {
        he: 'גרניט סרדו אפור ישירות מהמפעל. האבן החזקה בעולם למצבות, עמידה בפני כל מזג אוויר ואינה דורשת תחזוקה. 40 שנות אחריות מלאה.',
        en: 'Gray Granite Sardo directly from the factory. The strongest stone in the world for tombstones, weather-resistant and maintenance-free. Full 40-year warranty.'
      }
    },
    h1: {
      he: 'מצבות גרניט סרדו – עוצמה ועמידות לנצח',
      en: 'Granite Sardo Tombstones – Power and Durability Forever'
    },
    content: {
      intro: {
        he: 'אם אתם מחפשים \'ראש שקט\' ואבן שתיראה בדיוק אותו דבר גם בעוד 50 שנה – גרניט סרדו היא התשובה. זוהי אבן גרניט בגוון אפור מנוקד (פלפל-מלח), הנחשבת לאחת האבנים החזקות והעמידות ביותר בטבע.',
        en: 'If you are looking for \'peace of mind\' and a stone that will look exactly the same in 50 years – Granite Sardo is the answer. It is a granite stone with a speckled gray shade (pepper and salt), considered one of the strongest and most durable stones in nature.'
      },
      advantages: [
        {
          title: { he: 'אפס תחזוקה', en: 'Zero Maintenance' },
          description: { he: 'לא סופגת מים, לא מפתחת עובש, לא נסדקת ולא משנה צבע. הגשם מנקה אותה לבד.', en: 'Does not absorb water, does not develop mold, does not crack, and does not change color. The rain cleans it by itself.' }
        },
        {
          title: { he: 'חוזק מפלצתי', en: 'Monstrous Strength' },
          description: { he: 'עמידה בפני שריטות ומכות.', en: 'Resistant to scratches and blows.' }
        },
        {
          title: { he: 'מחיר הוגן', en: 'Fair Price' },
          description: { he: 'ביחס לגרניט השחור, הסרדו זול יותר ומספק תמורה אדירה למחיר.', en: 'Compared to black granite, Sardo is cheaper and provides tremendous value for the price.' }
        }
      ],
      suitability: {
        he: 'למי זה מתאים? למשפחות שרוצות את האופציה הפרקטית והעמידה ביותר, בלי להתעסק בחידוש וניקיון המצבה בעתיד.',
        en: 'Suitable for families who want the most practical and durable option, without dealing with renewing and cleaning the tombstone in the future.'
      }
    }
  },
  {
    id: 'black-granite',
    slug: 'black-granite',
    name: { he: 'גרניט שחור', en: 'Black Granite' },
    meta: {
      title: {
        he: 'מצבות גרניט שחור – פסגת היוקרה והעיצוב',
        en: 'Black Granite Tombstones – The Peak of Luxury and Design'
      },
      description: {
        he: 'מצבות גרניט שחור איכותי (Jet Black). מראה מבריק ויוקרתי, אפשרות לחריטת תמונות ועיטורים ברמה הגבוהה ביותר. יבוא אישי ללא תיווך.',
        en: 'High-quality Black Granite (Jet Black) tombstones. Shiny and luxurious look, possibility for laser engraving of photos and decorations at the highest level. Personal import without intermediation.'
      }
    },
    h1: {
      he: 'מצבות גרניט שחור – פסגת היוקרה והעיצוב',
      en: 'Black Granite Tombstones – The Peak of Luxury and Design'
    },
    content: {
      intro: {
        he: 'הגרניט השחור הוא \'היהלום\' של עולם המצבות. הצבע השחור העמוק והמבריק יוצר ניגודיות דרמטית ומכובדת בבית העלמין. באבני חן אנו משתמשים בגרניט שחור טהור (ולא צבוע!), המבטיח שהברק יישמר לאורך שנים רבות.',
        en: 'Black Granite is the \'diamond\' of the tombstone world. The deep and shiny black color creates a dramatic and dignified contrast in the cemetery. At Avne Chen, we use pure black granite (not painted!), ensuring that the shine is preserved for many years.'
      },
      advantages: [
        {
          title: { he: 'אסתטיקה מושלמת', en: 'Perfect Aesthetics' },
          description: { he: 'המראה המבריק והנקי ביותר שיש.', en: 'The shiniest and cleanest look available.' }
        },
        {
          title: { he: 'חריטה אומנותית', en: 'Artistic Engraving' },
          description: { he: 'על הרקע השחור ניתן לבצע חריטת לייזר של תמונת הנפטר, איורים וטקסטים מורכבים בחדות יוצאת דופן.', en: 'On the black background, laser engraving of the deceased\'s photo, illustrations, and complex texts can be performed with extraordinary sharpness.' }
        },
        {
          title: { he: 'יוקרה', en: 'Luxury' },
          description: { he: 'משדר מכובדות וייחודיות שקשה להתעלם ממנה.', en: 'Radiates dignity and uniqueness that is hard to ignore.' }
        }
      ],
      suitability: {
        he: 'למי זה מתאים? למי שמחפש את הטופ של הטופ. מצבה שתבלוט בשטח ותאפשר ביטוי אומנותי ואישי נרחב.',
        en: 'Suitable for those looking for the top of the top. A tombstone that will stand out in the field and allow extensive artistic and personal expression.'
      }
    }
  },
  {
    id: 'natural-rocks',
    slug: 'natural-rocks',
    name: { he: 'מצבות סלעים', en: 'Natural Rock Tombstones' },
    meta: {
      title: {
        he: 'מצבות מסלעים טבעיים – חיבור לטבע ולשורשים',
        en: 'Natural Rock Tombstones – Connection to Nature and Roots'
      },
      description: {
        he: 'עיצוב מצבות מסלעים טבעיים לא מעובדים. כל מצבה היא יצירה חד פעמית של הטבע. מגוון סלעי בזלת, לקט וגרניט פראי במפעל אבני חן.',
        en: 'Design of unpolished natural rock tombstones. Each tombstone is a one-time creation of nature. Variety of basalt, fieldstone, and wild granite rocks at Avne Chen factory.'
      }
    },
    h1: {
      he: 'מצבות מסלעים טבעיים – חיבור לטבע ולשורשים',
      en: 'Natural Rock Tombstones – Connection to Nature and Roots'
    },
    content: {
      intro: {
        he: 'לכל אדם יש את האופי שלו, ולעיתים האבן המלוטשת והסימטרית פחות מתאימה. מצבות מסלעים טבעיים מביאות את היופי הפראי של הטבע אל חלקת הקבר. אנו בוחרים סלעים ייחודיים מרחבי הארץ והעולם, ומשלבים בהם רק את אזור הכיתוב, תוך שמירה על הצורה הגולמית של האבן.',
        en: 'Every person has their own character, and sometimes the polished and symmetrical stone is less suitable. Natural rock tombstones bring the wild beauty of nature to the grave plot. We choose unique rocks from around the country and the world, and incorporate only the inscription area in them, while preserving the raw shape of the stone.'
      },
      advantages: [
        {
          title: { he: 'חד פעמיות', en: 'One-time' },
          description: { he: 'אין שני סלעים זהים. המצבה של יקירכם תהיה יחידה במינה.', en: 'No two rocks are identical. Your loved one\'s tombstone will be one of a kind.' }
        },
        {
          title: { he: 'עמידות', en: 'Durability' },
          description: { he: 'הסלע הטבעי שרד בטבע אלפי שנים, והוא ישרוד גם בבית העלמין ללא בלאי.', en: 'The natural rock has survived in nature for thousands of years, and it will also survive in the cemetery without wear.' }
        },
        {
          title: { he: 'חיבור רוחני', en: 'Spiritual Connection' },
          description: { he: 'מתאים מאוד לאנשים שאהבו טבע, אדמה ופשטות.', en: 'Very suitable for people who loved nature, earth, and simplicity.' }
        }
      ],
      suitability: {
        he: 'למי זה מתאים? למשפחות המחפשות הנצחה פחות \'מעונבת\' ויותר מחוברת לטבע ולנוף הארץ ישראלי.',
        en: 'Suitable for families looking for a less \'formal\' memorial and one more connected to nature and the Israeli landscape.'
      }
    }
  }
];

export const getStoneTypeById = (id) => stoneTypes.find(type => type.id === id);
export const getStoneTypeBySlug = (slug) => stoneTypes.find(type => type.slug === slug);




